import {Component, Vue} from 'vue-property-decorator';

@Component({
  components: {},
})
export default class JunkItFooterComponents extends Vue {

  public isMediaLessThanLG: boolean = false;

  onResize() {
    this.isMediaLessThanLG = window.innerWidth <= 1263;
  }

  public created() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }
}
